import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/fullExams/FullExamsPage.tsx")